import { useCallback, useEffect } from 'react';
import { useLocalStorage, createGlobalState } from 'react-use';

const useGlobalSwellSpectraOpenState = createGlobalState(false);
export const useGlobalSwellSpectraGraphOpen = () => useGlobalSwellSpectraOpenState();

const useStoredSwellSpectraGraphToggle = ({
  id,
}: {
  id: string;
}): {
  graphOpen: boolean;
  toggleGraph: () => void;
} => {
  const key = `sl_${id}_isExpanded`;
  const [graphOpenLocalStorage, setSwellSpectraGraphOpenLocalStorage] = useLocalStorage(key, true);
  const [isSwellSpectraOpen, setIsSwellSpectraOpen] = useGlobalSwellSpectraGraphOpen();

  useEffect(() => {
    if (graphOpenLocalStorage !== isSwellSpectraOpen) {
      // keep the state var in sync with the local storage var
      setIsSwellSpectraOpen(graphOpenLocalStorage ?? true);
    }
  }, [graphOpenLocalStorage, isSwellSpectraOpen, setIsSwellSpectraOpen]);

  const toggleGraph = useCallback(() => {
    setSwellSpectraGraphOpenLocalStorage(!isSwellSpectraOpen);
  }, [setSwellSpectraGraphOpenLocalStorage, isSwellSpectraOpen]);

  return { graphOpen: !!isSwellSpectraOpen, toggleGraph };
};

export default useStoredSwellSpectraGraphToggle;
